export enum DropdownOptions {
    Countries="country",
    Provinces="province",
    CompanyTypes="company_type",
    IndividualTypes="individual_type",
    DeliveryTypes="delivery_type",
    Gender="gender",
    Titles="title"
}